import * as sessionReplay from '@amplitude/session-replay-browser';
import { useEffect } from 'react';

import { sessionReplayState } from './sessionReplayState.ts';

// Stops Amplitude session replay once the user submits their first lineup
export const useSessionReplayShutdown = (hasCreatedFirstLineup: boolean) => {
  useEffect(() => {
    if (!sessionReplayState.active) return;
    if (hasCreatedFirstLineup) {
      sessionReplay.shutdown();
      sessionReplayState.active = false;
    }
  }, [hasCreatedFirstLineup]);
};
